export default __webpack_public_path__ + "static/ai-c4699001b99c1638c76545a8f3c90d13.svg";